import { COMMON_PROPERTIES, COMMON_PROPERTIES_SUBURBAN, RENTAL_PERIOD_SELECTED_OPTIONS } from './constants';
import { getTermValue, TJsonQueryKeys } from '../../../../JsonQuery';
import { IJsonQuery } from '../../types/jsonQuery';

function isCommonPropertiesSelected(jsonQuery: IJsonQuery, isRedesign: boolean) {
  if (jsonQuery._type === 'suburbansale') {
    // На время эксперимента не отображаем бейдж при изменении площади в загородке
    if (isRedesign && (jsonQuery.total_area || jsonQuery.site)) {
      return false;
    }

    return (Object.keys(jsonQuery) as TJsonQueryKeys[]).some(
      property => !COMMON_PROPERTIES_SUBURBAN.includes(property) && jsonQuery[property] !== undefined,
    );
  }

  return (Object.keys(jsonQuery) as TJsonQueryKeys[]).some(
    property => !COMMON_PROPERTIES.includes(property) && jsonQuery[property] !== undefined,
  );
}

function isRentalPeriodSelected(jsonQuery: IJsonQuery) {
  const rentalPeriod = getTermValue('for_day')(jsonQuery);

  return rentalPeriod !== null && RENTAL_PERIOD_SELECTED_OPTIONS.includes(rentalPeriod);
}

export function isAdvancedFiltersSelected(jsonQuery: IJsonQuery, isRedesign: boolean): boolean {
  return isCommonPropertiesSelected(jsonQuery, isRedesign) || isRentalPeriodSelected(jsonQuery);
}
